import dynamic from 'next/dynamic';
import { ConfirmationMessageProps } from './ConfirmationMessage.types';

export const ConfirmationMessageMGP = dynamic<ConfirmationMessageProps>(() => import('./ConfirmationMessage'));
